export default __webpack_public_path__ + "static/media/fortress-skid-plate.3a85fcea.mp4";